import {Directive, ElementRef, HostListener, Self} from '@angular/core';
import {NgbTooltip} from '@ng-bootstrap/ng-bootstrap';

/**
 * Shows the ngbTooltip on a truncated element only when its text is actually
 * clipped by the ellipsis. Pair it with a truncating class such as text-truncate.
 */
@Directive({
    selector: '[appEllipsisTooltip][ngbTooltip]',
    standalone: false
})
export class EllipsisTooltipDirective {

  constructor(
    private readonly el: ElementRef<HTMLElement>,
    @Self() private readonly tooltip: NgbTooltip
  ) {}

  @HostListener('mouseenter')
  onMouseEnter(): void {
    this.tooltip.disableTooltip = !this.isTextClipped();
  }

  private isTextClipped(): boolean {
    const element = this.el.nativeElement;
    return element.scrollWidth > element.clientWidth;
  }
}
